// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Import and expose Chart.js globally
import Chart from 'chart.js/auto'
window.Chart = Chart
